
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.389 1.667c1.183 0 2.15.925 2.218 2.091l.004.13v.742h2.963c.375 0 .685.278.734.64l.007.1a.74.74 0 01-.74.741h-.743l.001 9.63c0 1.183-.925 2.15-2.091 2.218l-.13.004H6.203a2.222 2.222 0 01-2.219-2.092l-.004-.13V6.11h-.74a.74.74 0 01-.734-.64l-.007-.1c0-.41.332-.741.74-.741h2.963v-.741c0-1.184.926-2.151 2.092-2.219l.13-.003h2.964zm2.963 4.443h-8.89l.001 9.63c0 .38.286.694.654.737l.087.005h7.407a.74.74 0 00.736-.655l.005-.086V6.11zm-2.963 2.223c.409 0 .74.332.74.741v4.444a.74.74 0 11-1.48 0V9.075c0-.409.33-.74.74-.74zm-2.963 0c.409 0 .74.332.74.741v4.444a.74.74 0 11-1.48 0V9.075c0-.409.33-.74.74-.74zm2.963-5.185H8.426a.74.74 0 00-.736.655l-.005.086v.74h4.444v-.74a.74.74 0 00-.654-.736l-.086-.005z"}})])
          )
        }
      }
    